import React from "react";
import "../styles/statusChip.scss";
import pendingSvg from "../svgs/pending.svg";
import approvedSvg from "../svgs/approved.svg";
import rejectedSvg from "../svgs/rejected.svg";

const label = {
  pending: "Pending",
  approved: "Approved",
  rejected: "Rejected",
};

const icon = {
  pending: pendingSvg,
  approved: approvedSvg,
  rejected: rejectedSvg,
};

export default function StatusChip({ status }) {
  const statusString =
    status === null ? "pending" : status ? "approved" : "rejected";

  return (
    <div className={`status-chip-container ${statusString}`}>
      <img src={icon[statusString]} alt="na" />
      {!!label[statusString] && label[statusString]}
    </div>
  );
}
